import * as actions from 'actions/HelpCentreActions/searchAction';
import { LOADING, INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import get from 'lodash/get';
const { searchActionsEnum } = actions;
const defaultState = {
    asyncStatus: INIT
};
export default function search(state = defaultState, action) {
    switch (action.type) {
        case searchActionsEnum.SEARCH_REQUEST:
            return {
                asyncStatus: LOADING
            };
        case searchActionsEnum.SEARCH_SUCCESS:
            //	This is beacuse loadsh get assigns default only incase of undefined not for null
            const faqs = get(action.data, ['faq', 'hits'], []) || [];
            return {
                asyncStatus: SUCCESS,
                faqs: faqs &&
                    faqs.map(faqWrap => {
                        let faq = faqWrap.hit || {};
                        return {
                            id: faq.baseId,
                            title: faq.question
                        };
                    })
            };
        case searchActionsEnum.SEARCH_ERROR:
            return {
                asyncStatus: ERROR
            };
        default:
            return state;
    }
}
